var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"overlay",class:_vm.overlayClasses,staticStyle:{"display":"none","opacity":"0"},style:(_vm.style),on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_c('div',{ref:"overlay-content",staticClass:"overlay-content",staticStyle:{"display":"none","opacity":"0"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }